export default function findDiff(text1, text2) {
  text1 = text1 || '';
  text2 = text2 || '';
  if (text1.length > text2.length) {
    let temp = text2;
    text2 = text1;
    text1 = temp;
  }
  text1 = normalizeSpaces(text1);
  text2 = normalizeSpaces(text2);
  let str1Idx = 0;
  let str2Idx = 0;
  let diffs = [];
  //eslint-disable-next-line no-constant-condition
  while (true) {
    if (str2Idx >= text2.length) {
      break;
    }
    if (text1.charAt(str1Idx) !== text2.charAt(str2Idx)) {
      diffs.push(text2.charAt(str2Idx));
      str2Idx++;
    } else {
      str1Idx++;
      str2Idx++;
    }
  }
  return diffs;
}
function findAddedChars(textBefore, textAfter) {
  let charsBefore = Array.from(normalizeSpaces(textBefore));
  let charsAfter = Array.from(normalizeSpaces(textAfter));
  let addedChars = [];
  charsAfter.forEach(item => {
    let index = charsBefore.indexOf(item);
    if (index === -1) {
      addedChars.push(item);
    } else {
      charsBefore.splice(index, 1);
    }
  });
  return addedChars;
}
function findRemovedChars(textBefore, textAfter) {
  return findAddedChars(textAfter, textBefore);
}
function normalizeSpaces(str) {
  return str.replace(/\u00a0/g, ' ').replace(/\u200b/g, '');
}
export { findAddedChars, findRemovedChars };